import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "album-dtm"
}
const _hoisted_2 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_3 = {
  key: 1,
  class: "avatars"
}

import { computed, defineAsyncComponent, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import * as utils from '@services/utils/common';
import * as dav from '@services/dav';
import { useRouteState } from '@services/route-state';
import { isAbortError, useAbort } from '@services/utils/abort-vue';

import MapMarkerOutlineIcon from 'vue-material-design-icons/MapMarkerOutline.vue';
import LinkIcon from 'vue-material-design-icons/Link.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AlbumDynamicTopMatter',
},
  __name: 'AlbumDynamicTopMatter',
  emits: ["load"],
  setup(__props, { expose: __expose, emit: __emit }) {

const NcAvatar = defineAsyncComponent(() => import('@nextcloud/vue/components/NcAvatar'));



const emit = __emit;

const route = useRoute();

const album = ref<dav.IDavAlbum | null>(null);
const abort = useAbort();

useRouteState({
  state: { album },
});

const isAvailable = computed((): boolean => !!utils.uid && !!albumUser.value && !!albumName.value);
const isReady = computed((): boolean => !isAvailable.value || !!album.value);

// Always return false since this is not "real" content.
// This way the empty view of the timeline will show on empty albums.
const isContent = computed((): boolean => false);

const albumUser = computed(() => {
  return route.params.user?.toString() ?? '';
});

const albumName = computed(() => {
  return route.params.name?.toString() ?? '';
});

async function refresh(): Promise<void> {
  // Skip everything if user is not logged in
  if (!utils.uid) return;

  // Skip if we are not on an album (e.g. on the list)
  const user = albumUser.value;
  const name = albumName.value;
  if (!user || !name) return;

  // Create an abort signal.
  const signal = abort.renew();

  // Get DAV album for collaborators
  try {
    const albumData = await dav.getAlbum(user, name, { signal });
    signal.throwIfAborted();
    album.value = albumData;
    emit('load');
  } catch (e) {
    if (isAbortError(e)) return;
    console.warn('Failed to fetch album:', e);
  } finally {
    if (!signal.aborted) {
      album.value ??= {
        collaborators: [],
        location: '',
      };
    }
  }
}

onMounted(refresh);

__expose({ isReady, isContent, refresh });

return (_ctx: any,_cache: any) => {
  return (isReady.value && album.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (album.value?.location)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(MapMarkerOutlineIcon, {
                class: "icon",
                size: 18
              }),
              _createElementVNode("span", null, _toDisplayString(album.value.location), 1)
            ]))
          : _createCommentVNode("", true),
        ((album.value?.collaborators.length ?? 0) > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(NcAvatar), {
                user: utils.uid!,
                showUserStatus: false
              }, null, 8, ["user"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(album.value.collaborators, (c) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (c.type === 3)
                    ? (_openBlock(), _createBlock(_unref(NcAvatar), {
                        key: 0,
                        isNoUser: true
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(LinkIcon, { size: 20 })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_unref(NcAvatar), {
                        key: c.id,
                        user: c.id,
                        showUserStatus: false
                      }, null, 8, ["user"]))
                ], 64))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})